import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Load } from '~hooks/useLoad/models';
import { GeofenceStartAdornment } from '~pages/Settings/Administration/Sites/components/GeofenceStartAdornment';
import { dateFormat } from '~utils/dateTime';
import { extractWaypointData } from '~utils/orders';

interface WaypointsColumnProps {
  load: Load;
  sx?: SxProps<Theme>;
}

export default function WaypointsColumn({ load, sx }: WaypointsColumnProps) {
  const { loadSummary } = load;

  const pickupTime = loadSummary?.arrivedPickupAt
    ? dateFormat(loadSummary.arrivedPickupAt, 'hh:mm A')
    : '-';
  const pickupWaypoint = extractWaypointData(load.pickUpWaypoints[0]);
  const pickup = { time: pickupTime, waypoint: pickupWaypoint };

  const time = loadSummary?.arrivedDropoffAt || loadSummary?.loadCompletedAt;
  const dropoffTime = time ? dateFormat(time, 'hh:mm A') : '-';
  const dropoffWaypoint = extractWaypointData(load.dropOffWaypoints[0]);
  const dropoff = { time: dropoffTime, waypoint: dropoffWaypoint };

  return (
    <Box sx={sx}>
      {[pickup, dropoff].map((site, index) => (
        <Box key={index} sx={{ display: 'grid', gridTemplateColumns: '80px 1fr' }}>
          <OverflowAwareText sx={{ fontWeight: 600 }}>{site.time}</OverflowAwareText>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <GeofenceStartAdornment geofenceType={site.waypoint?.geofenceType} />
            <OverflowAwareText
              sx={(theme) => ({ color: theme.brandV2.colors.treadGray2 })}
            >
              {site.waypoint?.name || '-'}
            </OverflowAwareText>
          </Box>
        </Box>
      ))}
    </Box>
  );
}
